<template>
    <v-container class="bg-color" fluid pa-0 v-if="active">
    <v-layout row class="mb-5">
            <v-flex xs12 sm12 md12 class="pr-0 text-xs-center">
        <div class="d-inline-flex">
            <v-btn class="pf-btn pf-btn-cancel" @click="cropClose">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="rotate">
            <v-icon size="16" class="pr-1">replay</v-icon>
            <div>Rotate</div>
            </v-btn>
        </div>
        </v-flex>
        </v-layout>
      <v-flex xs12>
        <div class="imageEditorApp flex xs12">
            <cropper
                ref="cropper"
                classname="cropper"
                :src="imgSrc"
                minWidth="20"
                minHeight="20"
                :wheelResize="false"
                :touchResize="false"
                :touchMove="false"
                :canvas="true"
                :stencil-props="{
                aspectRatio: 300/228,
                minAspectRatio: 4,
                maxAspectRatio: 10
                }"
            ></cropper>
    </div>
      </v-flex>
    </v-container>
</template>

<script>
/* global session store config */
import swal from 'sweetalert2';
import { Cropper } from 'vue-advanced-cropper';
import { upload } from '../helpers/aws';
import $ from 'jquery';
import { mapGetters } from 'vuex';

export default {
  name: 'Image-cropper',
  components: {
    Cropper
  },
  props: {
    photo: {
      type: Object,
      default: {}
    },
    active: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'album'
    }
  },
  data: () => ({
    imgSrc: '',
    cropImg: '',
    config: config
  }),
  computed: {
    ...mapGetters(['Album', 'AlbumPhoto', 'Account', 'Agency'])
  },
  watch: {
    photo: {
      handler: function (after, before) {
        let isSSL = window.location.protocol.indexOf('https') > -1;
        this.imgSrc =
          isSSL && this.photo.original_url
            ? this.photo.original_url
            : this.photo.original_url
              ? this.photo.original_url.replace('https', 'http') +
              '?' +
              Math.random()
              : '';
      },
      deep: true
    }
  },
  methods: {
    rotate () {
      let image = document.createElement('img');
      image.crossOrigin = 'anonymous';
      image.src = this.imgSrc;
      image.onload = () => {
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');
        if (image.width > image.height) {
          canvas.width = image.height;
          canvas.height = image.width;
          ctx.translate(image.height, image.width / image.height);
        } else {
          canvas.height = image.width;
          canvas.width = image.height;
          ctx.translate(image.height, image.width / image.height);
        }
        ctx.rotate(Math.PI / 2);
        ctx.drawImage(image, 0, 0);
        this.imgSrc = canvas.toDataURL();
      };
    },
    cropClose () {
      window.getApp.$emit('imageCrop', false, {});
    },
    async save () {
      const { coordinates, canvas } = this.$refs.cropper.getResult();
      this.cropImg = canvas.toDataURL('image/jpeg');
      window.getApp.$emit('saveProgress', true);
      const humanId = session.user().human.id;
      let albumId;
      if (session.role() === 'parent') {
        albumId = this.Account.avatar_album;
      } else {
        albumId = this.Agency.avatar_album;
      }
      let photoKey = this.config.s3Domain + '/' + humanId + '/album/' + albumId + '/original/' + this.photo.filename;
      let buf = Buffer.from(this.cropImg.replace(/^data:image\/\w+;base64,/, ''), 'base64');
      let { uploadError: uploadErrorThumb, response: uploadResponse } = await upload({
        Bucket: this.config.s3Bucket,
        Key: photoKey,
        Body: buf,
        ContentEncoding: 'base64', // required
        ContentType: `image/jpeg` // required. Notice the back ticks
      });

      if (uploadErrorThumb) {
        console.log(`Unable to upload thumb`, uploadErrorThumb);
      } else {
        if (session.role() === 'parent') {
          this.Account.avatar = `${this.config.s3BucketPath}${photoKey}`;
        } else {
          this.Agency.avatar = `${this.config.s3BucketPath}${photoKey}`;
        }
        window.getApp.$emit('imageCrop', false, {});
        window.getApp.$emit('saveProgress', false);
      }
    }

  },
};
</script>
<style scoped>
.cropper {
  height: calc(70vh - 50px);
}
.bg-color {
  background: #DDD;
  height: calc(100vh);
}

</style>


// WEBPACK FOOTER //
// src/components/ImageCropper.vue